/**
 * Configuration file for portfolio contact details and social links
 */

// Contact information
const contactConfig = {
  email: "sstoc095@uottawa.ca",
  location: "Ottawa, Ontario, Canada",
};

// Resume link
const resumeLink = "https://shanestock.dev/assets/Shane-Website-Resume.pdf";

// Social media links
const socialConfig = {
  github: {
    url: "https://github.com/Shane-CS",
    backgroundColor: "#333",
    icon: "fab fa-github",
  },
  linkedin: {
    url: "https://www.linkedin.com/in/shanestock/",
    backgroundColor: "#0077b5",
    icon: "fab fa-linkedin-in",
  },
  twitter: {
    url: "https://twitter.com/shanetech22",
    backgroundColor: "#1DA1F2",
    icon: "fab fa-twitter",
  },
  instagram: {
    url: "https://www.instagram.com/shane.stock22/",
    backgroundColor: "#E4405F",
    icon: "fab fa-instagram",
  },
  reddit: {
    url: "https://www.reddit.com/user/Shane_cs/",
    backgroundColor: "#FF0000",
    icon: "fab fa-reddit",
  },
};

// Export the configuration
export { contactConfig, resumeLink, socialConfig };